import React from 'react';
import "./usersData.css";

const UsersData = (props) => {
    const usersData = props.usersList.map(user=> (
        <>
            <tr key={user.id}>
                    <td>
                        {user.name}
                    </td>
                    <td>
                        {user.mail}
                    </td>
                    <td>
                        {user.phone}
                    </td>
                    <td>
                        {user.type}
                    </td>
                    <td>
                        {user.companyId}
                    </td>
                    <td>
                        {user.password}
                    </td>
                    <td>
                        <button className="actionButtonTable" value={user.id} onClick={props.handleDeleteUser}>Usuń</button>
                    </td>
            </tr>
        </>
    ))

    return ( 
        <>
            <div className="tableRow">
                <table className="usersTable">
                    <tbody>
                        <tr>
                            <th>Nazwa</th>
                            <th>Mail</th>
                            <th>Telefon</th>
                            <th>Rodzaj</th>
                            <th>Firma</th>
                            <th>Hasło</th>
                            <th>Akcja</th>
                        </tr>
                        {usersData}
                    </tbody>
                </table> 
            </div>  
        </>
    );
}
 
export default UsersData;